<template>
<div v-show="authenticated || SubHeader == 'FreqAsk'" class="transition : 1s">
    <inactivity-detection :secondsToTrigger="secondsToTrigger" modalId="logoutModal" type="logout">{{ TEXTS.render(`BOOKING_INACTIVITY`) }} </inactivity-detection>
    <AlertModal ref="alertAddressSearchValidation"></AlertModal>
    <div v-if="SubHeader === 'BookServiceHeader' && $store.getters.GET_PERSONAL_INFO.type === 'cso'" class="residentportal-header-login" v-bind:style="'background:' + backgroundRGB + 'flex: 1'" >
        <main-header></main-header>
        <div class="container">
            <div class="row">
                <div class="col-lg-12 residentportal-subheader">
                    <component :is="SubHeader"></component>
                    <div v-if="SubHeader === 'ReqCancellationHeader'" v-html="siteWordings || TEXTS.render('REQUESTCANCELLATION_SUBHEADER')"></div>
                    <!-- <inactivity-detection /> -->
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="residentportal-body-login text-dark">
                        <router-view ref="bookingsection"></router-view>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-if="((SubHeader !== 'BookServiceHeader') || (SubHeader === 'BookServiceHeader') && $store.getters.GET_PERSONAL_INFO.type === 'resident')" 
        class="residentportal-header-login" ref="residentportal-header-login"
        v-bind:style="'background:' + computedBackgroundRGB + 'flex: 1'" >
        <main-header></main-header>
        <div class="container">
            <div class="row">
                <div class="col-lg-12 residentportal-subheader">
                    <span class="text-center booking-banner" v-if="isToDisplayAddress">
                        <span><i class="icon icon-pin text--white"></i></span>
                        <h2 class="text-capitalize skiptranslate">{{activeAddressName()}}</h2>
                        <button type="button" class="btn btn--transparent mb-2" @click="changeAddress">{{ TEXTS.render(`BOOKING_BTN_CHANGE_ADDRESS`) }}</button>
                        <button type="button" v-if="isInBookingForm" class="btn btn--transparent mr-md-3 mb-2" @click="viewBookingHistory">{{ $store.getters.GET_SITE_WORDINGS.bookhistory_button_label || TEXTS.render(`BOOKING_BTN_BOOKING_HISTORY`, this.isEnabledBinCollection ? `binCollection` : `default`, null, {skipCasing:true}) }}</button>
                    </span>
                    <component :is="SubHeader"></component>
                    <div v-if="SubHeader === 'ReqCancellationHeader'" v-html="siteWordings || TEXTS.render('REQUESTCANCELLATION_SUBHEADER')"></div>
                    <!-- <inactivity-detection /> -->
                </div>
            </div>
        </div>
    </div>
    <div v-if="(SubHeader !== 'BookServiceHeader') || (SubHeader === 'BookServiceHeader' && $store.getters.GET_PERSONAL_INFO.type === 'resident')"  class="residentportal-body-login background">
        <router-view ref="bookingsection"></router-view>
    </div>
    <main-footer></main-footer>
    <div class="modal" tabindex="-1" role="dialog" id="pageLoadingModal" data-backdrop="static">
        <div class="modal-dialog modal-dialog-centered" role="document" style="height: 150px; flex-direction: column-reverse;">
            <p class="text-white mt-3" v-if="$route.path != '/booking/queued-bookings'">
                {{ TEXTS.render(`BOOKING_LOADING_NOTE`) }}
            </p>
            <h3 class="text-white mt-3">{{ TEXTS.render(`BOOKING_LOADING`) }}</h3>
            <div style="margin-top: 40%;">
                <page-loading-indicator />
            </div>
        </div>
    </div>
</div>
</template>
<script>
    import AlertModal from "../common/components/AlertModal";
    import GeneralBookingSettingMixin from '../common/mixins/GeneralBookingSettingMixin';
    import PageLoadingIndicator from '../common/components/PageLoadingIndicator';
    import BookServiceHeader from '../common/components/BookServiceHeader';
    import MainHeader from '../common/components/Header';
    import MainFooter from '../common/components/Footer';
    import InactivityDetection from '../common/components/InactivityDetection';
    import BookingStateManager from '../common/utils/BookingStateManager';
    import RetryWorker from '../common/utils/RetryWorker';
    import AccessibilityManager from '../common/utils/AccessibilityManager'
    import Texts from '../common/utils/Texts'
    
    const MyProfile = { template: Texts.render(`BOOKING_SECTION_HEADER_PROFILE`) };
    const FreqAsk = { template: Texts.render(`BOOKING_SECTION_HEADER_FAQ`) };
    const ReqCancellationHeader = { template: Texts.render(`BOOKING_SECTION_HEADER_REQUESTCANCELLATION`) };

    const routeSubHeader = {
        '/booking/home': 'BookServiceHeader',
        '/booking/my-profile': 'MyProfile',
        '/booking/faq': 'FreqAsk',
        '/booking/request-cancellation' : 'ReqCancellationHeader',
        '/booking/queue-bookings' : 'QueuedBooking'
    };

    export default {
        mixins : [GeneralBookingSettingMixin],
        data() {
            return {
                pubPath: process.env.MIX_APP_URL,
                activeAddress: null,
                authenticated : false
            }
        },
        components: {
            PageLoadingIndicator,
            MainHeader,
            MainFooter,
            InactivityDetection,
            BookServiceHeader,
            MyProfile,
            FreqAsk,
            AlertModal,
            ReqCancellationHeader
        },
        beforeCreate(){
            // Initialize Text Rendering Settings
            Texts.setModifiers({
                sentenceCase : true
            })
        },
        mounted() {
            // this.$store.dispatch('paymentAPI');
            this.$store.dispatch('getSiteWordingsSettings');
            new AccessibilityManager()
            this.$store.dispatch('bookingInit')
                .then(result => {
                    var email = this.personalInfo.email
                    if(email)
                        this.checkAuthentication(email)
                            .then(result=>{
                                if(result){
                                    this.authenticated = true                                }
                                else{
                                    this.$store.dispatch('logout');
                                }
                            })
                })
        
            if(this.SubHeader == 'ReqCancellationHeader') {
                this.$store.dispatch('getCancellationSetting');
            }
        },
        computed: {
            TEXTS : ()=> Texts,
            bookingState(){
                return this.$store.getters.GET_BOOKING_STATE;
            },
            personalInfo(){
                return this.$store.getters.GET_PERSONAL_INFO;
            },
            // paymentAPI: function () {
            //     return this.$store.getters.GET_PAYMENT_API;
            // },
            SubHeader() {
                return routeSubHeader[this.$route.fullPath];
            },
            MainUISettings() {
                return this.$store.getters['GET_MAIN_UI']; 
            },
            computedBackgroundRGB() { 
                var background = "linear-gradient(45deg, " + this.convertHex(this.$store.getters.GET_MAIN_UI.banner_gradient_dark)+ " 25%, " + this.convertHex (this.$store.getters.GET_MAIN_UI.banner_gradient_light) + " 79%), url("+ process.env.MIX_APP_URL + this.$store.getters.GET_MAIN_UI.banner_image +" );";
                return background;
            },
            backgroundRGB() {
                var background = "linear-gradient(45deg, " + this.convertHex(this.$store.getters.GET_MAIN_UI.banner_gradient_dark)+ " 25%, " + this.convertHex (this.$store.getters.GET_MAIN_UI.banner_gradient_light) + " 79%);";
                return background;
            },
            //Checking route full path if it is to display active address on the banner.
            isToDisplayAddress() {
                if(this.$route.fullPath.indexOf('/booking/form') > -1 || 
                    this.$route.fullPath.indexOf('/booking/history') > -1) {
                    return true;
                }
            },
            isInBookingForm(){
                return this.$route.fullPath.indexOf('/booking/form') > -1
            },
            websiteTitle(){
                return this.$store.getters.GET_WEBSITE_METADATA.title
            },
            secondsToTrigger(){
                // --- CR-3: Changing number of minutes to logout depending on the user type
                var secondsToTrigger
                const userType = this.$store.getters.GET_PERSONAL_INFO.type;
                switch(userType){
                    case "cso":
                        secondsToTrigger = 60 * 60 * 9 // 9 Hours
                        break;
                    default:
                        secondsToTrigger = 60 * 60 // 1 Hour
                }       

                return secondsToTrigger
            },
            siteWordings() {
                if(this.$store.getters.GET_CANCELLATION_SETTING && this.$store.getters.GET_CANCELLATION_SETTING.cancellation_subheader) {
                    return this.$store.getters.GET_CANCELLATION_SETTING.cancellation_subheader;
                } else {
                    return null;
                }
            },
        },
        methods:{
            convertHex(color) {
                color = color.replace('#', '')
                let r = parseInt(color.substring(0, 2), 16)
                let g = parseInt(color.substring(2, 4), 16)
                let b = parseInt(color.substring(4, 6), 16)
                let result = 'rgba(' + r + ',' + g + ',' + b + ',' + 0.75 + ')'
                return result
            },

            //Loads active address to display on the banner;
            activeAddressName() {

                // Check Path
                var addressName = "";

                var hasFormInUrl = window.location.href.indexOf('/booking/form') != -1
                var hasHistoryInUrl = window.location.href.indexOf('/booking/history') != -1

                if(hasHistoryInUrl){ // If History, pull from URL id
                    var bookingManager = new BookingStateManager();
                    var urlQuery = this.$route.query
                    var addressId = urlQuery.id
                    var address = bookingManager.getAddressFromMapById(addressId)
                    if(!address){
                        // Redirect Back to Home
                        this.$router.push('/booking/home');
                        location.reload()
                    }
                    addressName = address.displayName;
                }
                else if(hasFormInUrl){ // If in form, pull from booking State
                    var bookingState = this.bookingState
                    if(bookingState.activeAddress) {
                        addressName = bookingState.activeAddress.displayName;
                    }
                    
                }
                this.$store.dispatch('setBookingHistoryAddress', addressName)
                return addressName.toLowerCase();
            },
            changeAddress() {
                let route = this.$router.resolve({path: '/booking/home'});
                if(this.$store.getters.GET_PERSONAL_INFO.type == 'cso') {
                    window.open(route.href, '_blank');
                } else {
                    this.$router.push('/booking/home');
                }
            },
            viewBookingHistory() {
                  // Get the active address
                var activeAddress = this.bookingState.activeAddress
                if(!activeAddress){
                    return;
                }

                //Resets Step Form Index
                var id = activeAddress.id
                this.$store.dispatch('setActiveAddress', activeAddress);
                var bookingManager = new BookingStateManager();
                bookingManager.upsertAddressMap(activeAddress)
            

                var userType = this.$store.getters.GET_PERSONAL_INFO.type;
                var routeOptions = { path: 'history', query: { id: id }}
                switch(userType){
                    case 'cso':
                        let routeData = this.$router.resolve(routeOptions);
                        window.open(routeData.href, '_blank'); 
                        break;
                    default:
                        this.$router.push(routeOptions);
                        break;
                }
            },
            checkAuthentication(email){
                // Error 401 is Unauthorized
                var getEmail = email
                if(!email){
                    return;
                }
                return new Promise((mainResolve, mainReject) => {
                    new RetryWorker(10, 5000, 
                        function(){
                            return new Promise((resolve, reject) => {
                                if(!email){
                                    reject();
                                    return;
                                }
                                axios.get(process.env.MIX_API_URL + 'list-favorites', {
                                        params: {
                                            email: getEmail
                                        }
                                    })
                                    .then(response => {
                                        resolve({
                                            authenticated : true
                                        })
                                    })
                                    .catch(e => {
                                        if(e && e.response.status == 401){
                                            resolve({
                                                authenticated : false
                                            })
                                        }else{
                                            reject()
                                        }
                                    });
                            });
                        },  
                        function(result){
                            mainResolve(result.authenticated)
                        }
                    ).doWork()
                });
            }
        },
        watch: {
            '$route':{
                handler(to, from){
                    if(!this.websiteTitle){
                        this.$store.dispatch('setWebsiteMetadata', { title : 'unset'})
                    }

                    // Setup Document Title
                    if(this.websiteTitle == "unset"){
                        this.$store.dispatch('setWebsiteMetadata', { title : document.title})
                    }

                    // Apply Document Title if it exists
                    if( this.websiteTitle != "unset"){
                        if(to.meta.title && this.websiteTitle){
                            document.title = to.meta.title + " - " + this.websiteTitle
                        }else{
                            document.title = this.websiteTitle
                        }
                    }
                    
                },
                immediate: true
            },
            'SubHeader': function() {
                if(this.SubHeader == 'ReqCancellationHeader') {
                    this.$store.dispatch('getCancellationSetting');
                }
            }
        },
    }
</script>
